import { http } from '../http';
import { transformBlockListRow } from 'BlockList/utils/transformBlockListRow';
import type { BlockedAttribute, BlockListRow } from 'BlockList/types';

// ---------------------------------------------------------------------------
// Response shape (snake_case wire) — wrapped in { data: BlockedAttribute }
// ---------------------------------------------------------------------------

type ServerResponse = {
  data: BlockedAttribute;
};

// ---------------------------------------------------------------------------
// Service function
// ---------------------------------------------------------------------------

/**
 * POST /clearcover_admin/blocklist/attributes/{id}/deactivate
 *
 * No request body. Returns the updated BlockListRow (active: false,
 * deactivated_at set) on 200. Throws on 4xx/5xx so callers can extract
 * the error message via `extractReznorError`.
 */
export const deactivateBlockListAttribute = (token: string, id: string) => {
  return http.post<BlockListRow>(
    {
      url: `/clearcover_admin/blocklist/attributes/${id}/deactivate`,
      token,
      transformResponse: (jsonData: string | ServerResponse): BlockListRow => {
        const raw: ServerResponse =
          typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;
        return transformBlockListRow(raw.data);
      },
    }
    // no body
  );
};
